import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import {
    getTrackingsApi,
    getTrackingByIdApi,
    downloadTrackingLabelApi,
    downloadTrackingLabelQRCodeApi,
} from "../../../services/tracking";

export const getTrackings = createAsyncThunk('tracking/getTrackings', async (data, { dispatch }) => {
    const response = await getTrackingsApi(data);
    dispatch(setTrackingsData(response.response));
    return response.response;
});

export const getTrackingById = createAsyncThunk('tracking/getTrackingById', async (id) => {
    const response = await getTrackingByIdApi(id);
    return response.response;
});

export const downloadTrackingLabel = createAsyncThunk('tracking/downloadTrackingLabel', async (data) => {
    const response = await downloadTrackingLabelApi(data);
    return response.response;
});

export const downloadTrackingLabelQRCode = createAsyncThunk('tracking/downloadTrackingLabelQRCode', async (data) => {
    const response = await downloadTrackingLabelQRCodeApi(data);
    return response.response;
});

const trackingAdapter = createEntityAdapter({});

const trackingSlice = createSlice({
    name: 'tracking',
    initialState: trackingAdapter.getInitialState({
        trackingsList: [],
        trackingsTableRow: 0,
        trackingDetails: null,
    }),
    reducers: {
        setTrackingsData: (state, action) => {
            state.trackingsList = action.payload.data || [];
            state.trackingsTableRow = action.payload.count || 0;
        },
        clearTrackingDetails: (state) => {
            state.trackingDetails = null;
        },
    },
    extraReducers: {
        [getTrackingById.fulfilled]: (state, action) => {
            state.trackingDetails = action.payload;
        },
    }
});

export const {
    setTrackingsData,
    clearTrackingDetails,
} = trackingSlice.actions;

export default trackingSlice.reducer;